import {Injectable} from '@angular/core';
import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import {isObject} from 'lodash';

@Injectable()
export class SentryMissingTranslationHandler implements MissingTranslationHandler {
  private sentKeys = [];

  private transformKeysToJson(keys: string[]): object {
    const result = {};
    keys.forEach(key => {
      const parts = key.split('.');
      let current = result;
      parts.forEach((part, index) => {
        if (index === parts.length - 1) {
          current[part] = '';
        } else {
          current[part] = current[part] || {};
          current = current[part];
        }
      });
    });
    return result;
  }

  handle(params: MissingTranslationHandlerParams) {
    if (Object.keys(params.translateService.store.translations).length === 0) {
      return;
    }
    const key = params.key;
    if (!this.sentKeys.includes(key)) {
      // console.error('Missing translation for key: ' + key + ' and language: ' + params.translateService.currentLang);
      // Sentry.captureMessage('Missing translation for key: ' + key + ' and language: ' + params.translateService.currentLang);
      this.sentKeys.push(key);
    }
    return key;
  }
}
